import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";

import "antd/dist/reset.css";
import "./style.scss";

import App from "containers/App/App";
import reportWebVitals from "./reportWebVitals";

document.documentElement.lang = "uk";
document.documentElement.translate = false;
document.documentElement.classList.add("notranslate");
document.body.translate = false;
document.body.classList.add("notranslate");

const rootElement = document.getElementById("root") as HTMLElement;
rootElement.translate = false;
rootElement.classList.add("notranslate");

const root = ReactDOM.createRoot(rootElement);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
